<ng-container [formGroup]="form">
	<ng-select class="custom" appendTo="body" formControlName="optionId" [placeholder]="placeholder()">
		@for (item of options(); track item.id) {
			<ng-option [value]="item.id">{{ item.name }}</ng-option>
		}
	</ng-select>
</ng-container>
